import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable()
export class AdmissionServiceApiConfiguration {

    constructor() {
        this.server = environment.admission;
    }

    server: string;
    consultationType = {
        url: 'ConsultationType',
        activeByFilter: 'ConsultationType/ActiveByFilter',
        getConsultationTypesLookup: 'ConsultationType/ConsultationTypesLookup',
    };

    class = {
        url: 'Class',
        getFilterClass: 'Class/GetFilterClass',
        defaultClassByPatientId: 'Class/DefaultClassByPatientId',
    };

    admissionReason = {
        url: 'AdmissionReason',
        byId: 'AdmissionReason/ById',
        bySearch: 'AdmissionReason/BySearch',
        bySearchPaged: 'AdmissionReason/BySearchPaged',
    };

    room = {
        url: 'Room',
        getByClassOrBoth: 'Room/GetByClassOrBoth',
        getByClassAndSection: 'Room/GetByClassAndSection',
        RoomAvailabilityByClass: 'Room/ClassesRoomBedAvailability',
        RoomAvailabilityBySection: 'Room/AvailableSectionPercentage',
    };

    bed = {
        url: 'Bed',
    };

    bedAvailability = {
        url: 'BedAvailability',
    };

    bedStatus = {
        toCanceled: 'BedStatus/ChangeBedStatusToCanceled?bedId=',
        toOccupied: 'BedStatus/ChangeBedStatusToOccupied?bedId=',
    };

    reservation = {
        url: 'Reservation',
        bySearch: 'Reservation/BySearch',
        byId: 'Reservation/ById',
        cancelReservation: 'Reservation/CancelReservation',
    };

    companion = {
        url: 'Companion',
    };

    companionPeriods = {
        url: 'CompanionPeriods',
    };

    admission = {
        url: 'Admission',
        doctorRelease: 'Admission/DoctorRelease',
        openToRelease: 'Admission/OpenToRelease',
        releaseToOpen: 'Admission/ReleaseToOpen',
        admissionReasonByAdmissionId: 'Admission/AdmissionReasonByAdmissionId',
        notifyPyxisOnPatientUpdate: 'Admission/NotifyPyxisOnPatientUpdate',
        notifyPyxisOnMergePatient: 'Admission/NotifyPyxisOnMergePatient',
        setReleaseDate: 'Admission/SetReleaseDate',
        setDischargeDate: 'Admission/SetDischargeDate',
        getReleaseDate: 'Admission/GetReleaseDate',
        publishAdmissionHistory: 'Admission/AdmissionHistory',
        setAdmissionDoctor: 'Admission/SetAdmissionDoctor',
    };

    transfer = {
        url: 'Transfer',
    };

    inpatientTimelineHistory = {
        inpatientHistory: 'Admission/PatientHistory',
    };

    admissionReportSetup = {
        url: 'AdmissionReportSetup',
    };

    consultationTypesDetail = {
        url: 'ConsultationTypesDetail',
        getWalkInVisitService: 'ConsultationTypesDetail/getWalkInVisitService',
    };

    consultationDoctor = {
        url: 'consultationDoctor',
        getConsultingDoctorByAdmissionId: 'consultationDoctor/ByAdmissionId',
        postConsultingDoctor: 'consultationDoctor/PostConsultingDoctor',
        updateConsultingDoctor: 'consultationDoctor/UpdateConsultingDoctor'
    };

}
